import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

const CRMLayout = () => {
    const location = useLocation();
    // e.g., location.pathname = '/crm/leads/businesses', so basePath = '/crm/leads'
    const basePath = location.pathname.split('/').slice(0, 3).join('/');

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-gray-800">
                    {basePath.includes('leads') && 'Lead Management'}
                    {basePath.includes('customers') && 'Customer Management'}
                    {basePath.includes('campaigns') && 'Campaign Management'}
                </h1>
            </div>

            {/* Tab Navigation for Business vs. Profile */}
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-6" aria-label="Tabs">
                    <NavLink
                        to={`${basePath}/businesses`}
                        className={({ isActive }) =>
                            `whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                                isActive ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`
                        }
                    >
                        Businesses
                    </NavLink>
                    <NavLink
                        to={`${basePath}/profiles`}
                        className={({ isActive }) =>
                            `whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                                isActive ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`
                        }
                    >
                        Profiles
                    </NavLink>
                </nav>
            </div>

            {/* The nested route component will be rendered here */}
            <div className="mt-6">
                <Outlet />
            </div>
        </div>
    );
};

export default CRMLayout;